import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CartItems from "./CartItems";
import ProceedCheckout from "./ProceedCheckout";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import { useDispatch, useSelector } from "react-redux";
import { cancelModifyOrder, clearCartList, clearCateringCartList, getCartList } from "redux/actions";
import "./your-cart.scss";
import ClearCartConfirmationModal from "./ClearCartConfirmationModal";
import AddToMyList from "components/AddToMyList";
import { resetSelectedCartCustomOption, addMultipleProductToList } from "redux/actions";
import { getLocalStorageValue } from 'config/helper';
import { useApiDefaults } from 'hooks/useApiDefaults';
import { useGotoLogin } from 'hooks/useGotoLogin';
import { useConfigHeader } from 'hooks/useConfig';
import axios from "config/axios";

const ALLOW_SUBSTITUTE_FOR_ALL_OPTION = [
  'localhost',
  'redners-markets-beta.web.app',
  'redners-markets.web.app',
  'www.rednersmarkets.com',
  'www.costboss.com',
].includes(window.location.hostname);

const YourCart = () => {
  const dispatch = useDispatch();
  const gotoLogin = useGotoLogin();
  const Navigate = useNavigate();
  const { cartType } = useParams();
  const [isShowMyListDropdown, setShowMyListDropdown] = useState(false);
  const [isShowNewListModal, setShowNewListModal] = useState(false);

  const [isShowClearCartConfirmModal, setShowClearCartConfirmModal] =
    useState(false);
  const [substituteForAll, setSubstituteForAll] = useState(true);
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const clientId = getLocalStorageValue("RSAclient-id");

  const { currentStoreID } = useSelector(({ store }) => store);

  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const { modifyOrderId, cancellingModifyOrder, cancellingModifyOrderError } = useSelector(({ checkout }) => checkout);

  const {
    productCartList: groceryProductCartList,
    clearCartListLoading,
    cateringAndMealKitProductCartList,
  } = useSelector(({ cartWishlist }) => cartWishlist);

  const {
    addMultipleProductLoading
  } = useSelector(({ customlist }) => customlist);

  let productCartList = groceryProductCartList;
  if (cartType === "catering-meal") {
    productCartList = cateringAndMealKitProductCartList;
  }

  const apiDefaults = useApiDefaults()
  useEffect(() => {
    if (isUserLoggedIn) {
      dispatch(getCartList(apiDefaults));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoggedIn]);

  useEffect(() => {
    return () => {
      dispatch(resetSelectedCartCustomOption());
    };
  }, []); // eslint-disable-line

  const breadcrumbList = [{ lable: "Your cart", link: "" }];

  const handleClickClearCart = () => {
    setShowClearCartConfirmModal(true);
  };

  const handleClearingCart = () => {
    let clearCartFunc, body
    if (cartType === "catering-meal") {
      body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        meal_cart_id: productCartList[0] && productCartList[0].meal_cart_id,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
      };
      clearCartFunc = clearCateringCartList
    } else {
      body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        cart_id: productCartList[0] && productCartList[0].cart_id,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
      };
      clearCartFunc = clearCartList
    }

    dispatch(clearCartFunc(body)).then(() => {
      dispatch(getCartList(apiDefaults));
    });
  };

  const { is_mealkit = "0" } = cateringAndMealKitProductCartList[0] || {};
  const {allowGrocery, allowCatering } = useConfigHeader()
  const navigate = useNavigate()

  useEffect(() => {
    if (+is_mealkit === 0) {
      if (!allowGrocery) {
        navigate("/")
      }
    } else if (!allowCatering) {
      navigate("/")
    }
  }, [allowCatering, allowGrocery, is_mealkit, navigate])

  let yourCartHeader = "Your Grocery Order";
  if (clientId == 347) {
    yourCartHeader = "Your Cart";
  } else if (cartType === "catering-meal") {
    if (is_mealkit === "1") {
      yourCartHeader = "Your Food Order";
    } else {
      yourCartHeader = "Your Catering Order";
    }
  }

  const handleAddToWishlist = (list_id) => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      items_data: productCartList.map(product => {
        return {
          product_id: product.product_id,
          qty: product.qty,
        }
      }),
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      list_id,
    };

    isUserLoggedIn &&
      dispatch(addMultipleProductToList(body)).then(() => {
        setShowMyListDropdown(false);
      });
  };

  const handleCancelModifyOrder = () => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      cart_id: productCartList[0] && productCartList[0].cart_id,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      modify_order_id: modifyOrderId,
    };
    dispatch(cancelModifyOrder(body, () => {
      Navigate("/myaccount/myOrderTheme2")
    }));
  };

  const [updatingSubstituteForAll, setUpdatingSubstituteForAll] = useState(false);
  const handleEnableSubstituteForAll = async () => {
    try {
      if (updatingSubstituteForAll) return
      
      setUpdatingSubstituteForAll(true);
  
      const targetValue = substituteForAll ? "Yes" : "No";
  
      const mulitple_substitu_items = productCartList?.filter(p => Array.isArray(p.custom_options_select) && p.custom_options_select.some(c => c.type === "dropdown"))
        .map((product) => {
          const custom_options_arr = []
          for (const option of product.custom_options_select) {
            if (option?.title === "Allow Substitution?" && option?.type === "dropdown" && option?.values?.length) {
              // find and select yes/no for allow substitute
              const targetOptionValue = option.values.find(v => v.value === targetValue)
              if (targetOptionValue) {
                custom_options_arr.push({
                  ...targetOptionValue,
                  label: option.title,
                  is_add_option_price: option.is_add_option_price,
                  is_multiply_option_price_against_base_price: option.is_multiply_option_price_against_base_price,
                })
              } else {
                console.log(`❌ could not find "${targetValue}" option in "Allow Substitution?" options!`)
              }
            } else {
              // use same selected value if it's not "Allow Substitution?"
              const selectedOption = product.custom_options_arr.find(i => i.label === option.title)
              if (selectedOption) {
                custom_options_arr.push(selectedOption)
              }
            }
          }
  
          return {
            item_id: product.item_id,
            custom_options_arr,
          } 
        })
  
      const defaultValues = {...apiDefaults}
      delete defaultValues.PageNo
      const body = {
        ...apiDefaults,
        page_name: "my_cart",
        mulitple_substitu_items
      }
      const res = await axios.post('/AogEditCartItemCustomOption', body)
      if (res.data.status === "success") {
        dispatch(getCartList(apiDefaults));        
        setSubstituteForAll(!substituteForAll);
      }
    } catch (error) {
      console.log('❌ ERROR ', error)      
    } finally {
      setUpdatingSubstituteForAll(false)
    }
  };


  return (
    <>
      <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={`Your cart`} />
      <div className="container your-cart-section-align">
        {modifyOrderId ? (
          <div className="cart-notify">
            * You are currently modifying order #{modifyOrderId}.{" "}
            <span onClick={handleCancelModifyOrder}> {cancellingModifyOrder ? "Cancelling..." : "Do not want to modify order"}</span>
            {cancellingModifyOrderError ? <span className="error-message">{cancellingModifyOrderError}</span> : null}
          </div>
        ) : null}

        <div className="cart-title">
          <h1>
            {yourCartHeader}{" "}
            {modifyOrderId ? (
              <span className="cart-order-id">(Order #{modifyOrderId})</span>
            ) : null}
          </h1>
          <p style={{ fontSize: "14px", marginTop: "5px" }}>
            There {productCartList?.length > 1 ? "are" : "is"}{" "}
            {productCartList?.length}{" "}
            {productCartList?.length > 1 ? "products" : "product"} in your cart
          </p>
        </div>
        <div className="page-grid-align">
          <div>
            <div className="continue-shopping">
              <Link
                to={
                  cartType === "catering-meal"
                    ? "/catering-meal"
                    : "/search/products/*"
                }
              >
                <button>
                  <i className="fa-solid fa-left-long"></i>
                  <span>
                    {clientId == 347 ? "Continue Browsing" : "Continue Shopping"}
                  </span>
                </button>
              </Link>
            </div>
          </div>
          <div className="cart-action-align">
            {/* <div className="check-reward">
              <button>Check your reward</button>
            </div> */}

             {cartType || !ALLOW_SUBSTITUTE_FOR_ALL_OPTION
             ? null
             : <div className="continue-shopping">
                  <button onClick={handleEnableSubstituteForAll} disabled={updatingSubstituteForAll}>
                      <span>{updatingSubstituteForAll ? "Updating..." : substituteForAll ? "Enable" : "Disable"} substitute for all</span>
                  </button>
              </div>}

            <AddToMyList
              isShowMyListDropdown={isShowMyListDropdown}
              isShowNewListModal={isShowNewListModal}
              setShowNewListModal={setShowNewListModal}
              setShowMyListDropdown={setShowMyListDropdown}
              title={
                addMultipleProductLoading ? "Saving to list" : "Add to my list"
              }
              handleApply={handleAddToWishlist}
            />

            <div className="clear-cart">
              {clearCartListLoading ? (
                <div className="clear-icon disabled">
                  <i className="fa-solid fa-trash-can"></i> Clearing...
                </div>
              ) : (
                <div
                  className={
                    productCartList && !!productCartList.length
                      ? "clear-icon"
                      : "clear-icon disabled"
                  }
                  onClick={handleClickClearCart}
                >
                  <i className="fa-solid fa-trash-can"></i> Clear Cart
                </div>
              )}
            </div>

            <ClearCartConfirmationModal
              isShow={isShowClearCartConfirmModal}
              onClose={() => setShowClearCartConfirmModal(false)}
              onClear={handleClearingCart}
            />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="your-cart-section">
          <div className="cart-grid">
            <div className="cart-grid-items">
              <CartItems
                productCartList={productCartList}
                cartType={cartType}
              />
            </div>
            <div className="cart-grid-items">
              <ProceedCheckout
                productCartList={productCartList}
                cartType={cartType}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default YourCart;
